import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';

export const api = {
  getInternalUser: (url: string, login: string, forceCheck: boolean): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/internal/internal-users/${login}`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        forceCheck: forceCheck,
      },
    }),

  setPrimaryOU: (url: string, id: string): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/internal-users/org-units/${id}/setPrimary`,
      {},
      {
        params: {
          channel: ChannelType.MO2_CARE,
          customerMasterSource: CustomerMasterSourceType.O2POP,
        },
      }
    ),

  setSelectedRole: (url: string, id: string): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/internal-user-roles/${id}/setPrimary`,
      {},
      {
        params: {
          channel: ChannelType.MO2_CARE,
          customerMasterSource: CustomerMasterSourceType.O2POP,
        },
      }
    ),

  getInternalUserList: (
    url: string,
    searchString: string,
    page: string,
    pageSize: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/internal/internal-users`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        searchString: searchString,
        page: page,
        pageSize: pageSize,
        sort: 1,
      },
    }),

  getNavigationLinks: (url: string): Promise<ExtendedAxiosResponse> => apiClient.get(url),
};
